import { Field, Model } from 'serialize-ts';

@Model()
export class Brand {
  @Field()
  id: string;

  @Field()
  name: string;
}
